import { render, staticRenderFns } from "./dubbingInfoModal.vue?vue&type=template&id=145b7759&scoped=true"
import script from "./dubbingInfoModal.vue?vue&type=script&lang=js"
export * from "./dubbingInfoModal.vue?vue&type=script&lang=js"
import style0 from "./dubbingInfoModal.vue?vue&type=style&index=0&id=145b7759&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145b7759",
  null
  
)

export default component.exports